<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M10.8 5.7648C9.49168 5.12779 8.0552 4.79781 6.60002 4.8c-1.506 0-2.9316.348-4.2.9648v12c1.30836-.637 2.74483-.9669 4.2-.9648 2.0028 0 3.86158.612 5.39998 1.662 1.5913-1.0857 3.4736-1.6651 5.4-1.662 1.506 0 2.9316.348 4.2.9648v-12c-1.3083-.63701-2.7448-.96699-4.2-.9648-1.506 0-2.9316.348-4.2.9648V14.4c0 .3183-.1264.6235-.3514.8485-.2251.2251-.5303.3515-.8486.3515-.3182 0-.6235-.1264-.8485-.3515-.225-.225-.3515-.5302-.3515-.8485V5.7648Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M2.44662 5.42007C3.79696 4.52293 5.58036 4 7.5 4c1.66769 0 3.2326.39467 4.5 1.08651C13.2674 4.39467 14.8323 4 16.5 4c1.9207 0 3.7031.52296 5.0534 1.42007.2789.18534.4466.49802.4466.83293v13c0 .3685-.2027.7072-.5274.8813-.3248.1741-.719.1556-1.026-.0484C19.4609 19.431 18.0733 19 16.5 19c-1.5724 0-2.961.4311-3.9466 1.0859-.3353.2228-.7715.2228-1.1068 0C10.461 19.4311 9.07236 19 7.5 19c-1.57236 0-2.96096.4311-3.94662 1.0859-.30694.204-.70117.2225-1.02594.0484C2.20268 19.9602 2 19.6215 2 19.253v-13c0-.33491.16766-.64759.44662-.83293ZM11 6.81949C10.0603 6.31667 8.84766 6 7.5 6c-1.34766 0-2.56033.31667-3.5.81949V17.6261C5.0538 17.2225 6.24792 17 7.5 17c1.25208 0 2.4462.2225 3.5.6261V6.81949Zm2 10.80661C14.0538 17.2225 15.2479 17 16.5 17c1.2527 0 2.4465.2224 3.5.626V6.81947C19.0605 6.31664 17.8485 6 16.5 6c-1.3477 0-2.5603.31667-3.5.81949V17.6261Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
